import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/api/test/';
const API_URL = process.env.VUE_APP_API_BASE_URL + '';

class UserService {
  changePassword(user_id, new_password) {
    return axios
      .put('users/'+user_id+'/password', {"password": new_password })
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }
  updateContact(user_id, contact) {
    return axios
      .put('users/'+user_id+'/contact', contact)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }
  getUser(user_id) {
    return axios
      .get('users/'+user_id)
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }
  enrollTOTP(user_id) {
    return axios
      .put('users/'+user_id+'/enroll_totp')
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }
  removeTOTP(user_id) {
    return axios
      .put('users/'+user_id+'/remove_totp')
      .then(response => response)
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }
  getTOTPQRurl(url) {
    return API_URL + 'tools/get_totp_qrcode?url=' + url
  }
  getTOTPQRImage(url) {
    return axios
      .get('tools/get_totp_qrcode?url=' + url, { responseType: 'arraybuffer' })
      .then(response => Buffer.from(response.data, 'binary').toString('base64'))
      .catch(error => { throw(error) })
      .finally(() => {
      })
  }
}


export default new UserService();